import React from "react";
import { Link } from "react-router-dom";

function HomeScreenPopularPDFTools() {

  return (
    <div className="container text-center">
      {/* Title */}
      <div style={{ marginTop: "6rem" }}>
        <label className="display-6 fw-bold text-dark">
          Your Favourite PDF Tools
        </label>
      </div>

      <div className=" mt-2">
        <label className="fs-6">
          Free pdf tools. No Download. Edit Online/Offline.
        </label>
      </div>

      {/* Popular Tools grid */}
      <div className="mt-5">
        <div className="row g-2">

          {/* PDF Compressor */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link
              to="/compress_pdf"
              state={{ title: "Compress PDF files" }}
              className="text-decoration-none text-dark"
            >
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Compress PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Reduce size of PDF without losing quality.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* PDF Merger */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/merge_pdf"
              state={{ title: "Merge PDF files" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Merge PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Combine two or more PDFs into one unified document.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* PDF Splitter */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/split_pdf"
              state={{ title: "Split PDF in parts" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Split PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Split a PDF into two or more documents.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* PDF to JPG */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/pdf_to_image"
              state={{ title: "PDF to Image Converter" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">PDF to JPG</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Export PDF pages as .jpg, .png etc.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* JPG to PDF */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/image_to_pdf"
              state={{ title: "JPG to PDF Converter" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">JPG to PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Convert any .jpg, .png, .bmp, .gif images to PDF document.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Watermark PDF */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/watermark_pdf"
              state={{ title: "Watermark PDF documents" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Watermark PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Add watermarks to PDF documents and protect your IP.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Lock PDF */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/lock_pdf"
              state={{ title: "Change PDF password, Lock PDF" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Lock PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Password protect your PDF document file.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          {/* Unlock PDF */}
          <div className="col-12 col-sm-6 col-md-3">
            <Link to="/unlock_pdf"
              state={{ title: "Unlock PDF files" }}
              className="text-decoration-none text-dark">
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Unlock PDF</h5>
                    <img loading="lazy" style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png" alt="" />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Remove password from any PDF document.
                  </p>
                </div>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default HomeScreenPopularPDFTools;
